import React from 'react';
import { useTranslation } from 'react-i18next';
import NavButtons from '../components/NavButtons';
import StepHeading from '../components/StepHeading';
import TextField from '../components/TextField';
import { BD } from '../bookDemoTheme';

interface BusinessNameStepProps {
  value: string;
  onChange: (value: string) => void;
  onBack: () => void;
  onContinue: () => void;
}

const BusinessNameStep: React.FC<BusinessNameStepProps> = ({
  value,
  onChange,
  onBack,
  onContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col flex-1">
      <StepHeading title={t('bookDemo.name.title')} subtitle={t('bookDemo.name.subtitle')} />

      <div className={`max-w-[606px] mx-auto w-full rounded-xl border p-4 sm:p-5 ${BD.cardBg} ${BD.borderStrong}`}>
        <TextField
          id="bookDemoBusinessName"
          label={t('bookDemo.name.label')}
          value={value}
          onChange={onChange}
          placeholder={t('bookDemo.name.placeholder')}
          autoComplete="organization"
        />
      </div>

      <NavButtons onBack={onBack} onContinue={onContinue} continueDisabled={value.trim().length === 0} />
    </div>
  );
};

export default BusinessNameStep;
